'use client';

import React, { useEffect } from 'react';
import Filters from './out-material-filter';
import OutputMaterialTable from './output-material-table';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import {
  selectOutputMaterialsData,
  selectOutputMaterialsError,
  selectOutputMaterialsLoading,
} from '../../store/match-maker.selectors';
import { getOutputMaterialList } from '../../store/match-maker.thunk';
import { MaterialFilterEnum } from '../../utils/match-maker.enums';

const OutputMaterialListWrapper: React.FC = () => {
  const dispatch = useAppDispatch();
  const outputMaterialsData = useAppSelector(selectOutputMaterialsData);
  const isLoading = useAppSelector(selectOutputMaterialsLoading);
  const error = useAppSelector(selectOutputMaterialsError);

  useEffect(() => {
    dispatch(
      getOutputMaterialList({
        sort_field: MaterialFilterEnum.DESCRIPTION,
        sort_order: MaterialFilterEnum.SORT_ASC,
      })
    );
  }, [dispatch]);

  return (
    <div className="border border-gray-300 rounded-lg bg-white w-full">
      <Filters />
      <OutputMaterialTable
        outputMaterialsData={
          isLoading ? { items: [], total: 0 } : outputMaterialsData
        }
        isLoading={isLoading}
        error={error}
      />
    </div>
  );
};

export default OutputMaterialListWrapper;
